/* eslint-disable import/prefer-default-export */
import { SET_TEXT_SIZE, LS_TEXT_SIZE } from 'constants/index';

export function setTextSize(payload) {
  localStorage.setItem(LS_TEXT_SIZE, payload);
  return dispatch => {
    dispatch({ type: SET_TEXT_SIZE, payload });
  };
}
